/**
 * convert number into million, billion and in k's
 */
export const numberConvert = (
  labelValue: string | number,
  full = false,
  toFixedValue = 1 // Define how many digits you want to show after decimal point.
) => {
  if (full) {
    // Nine Zeroes for Billions
    const number =
      Math.abs(Number(labelValue)) >= 1.0e9
        ? `${(Math.abs(Number(labelValue)) / 1.0e9).toFixed(
            toFixedValue
          )} billion`
        : // Six Zeroes for Millions
        Math.abs(Number(labelValue)) >= 1.0e6
        ? `${(Math.abs(Number(labelValue)) / 1.0e6).toFixed(
            toFixedValue
          )} million`
        : // Three Zeroes for Thousands
        Math.abs(Number(labelValue)) >= 100.0e3
        ? `${(Math.abs(Number(labelValue)) / 1.0e3).toFixed(toFixedValue)}k`
        : Math.abs(Number(labelValue));

    return number;
  }
  // Nine Zeroes for Billions
  const number =
    Math.abs(Number(labelValue)) >= 1.0e9
      ? `${(Math.abs(Number(labelValue)) / 1.0e9).toFixed(toFixedValue)}b`
      : // Six Zeroes for Millions
      Math.abs(Number(labelValue)) >= 1.0e6
      ? `${(Math.abs(Number(labelValue)) / 1.0e6).toFixed(toFixedValue)}m`
      : // Three Zeroes for Thousands
      Math.abs(Number(labelValue)) >= 1.0e3
      ? `${(Math.abs(Number(labelValue)) / 1.0e3).toFixed(toFixedValue)}k`
      : Math.abs(Number(labelValue));

  return number;
};

/**
 * convert seconds into hour, min and seconds
 */
export const numberFormat = (number: number) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
